import Axios from '../utils/Axios';
import axios, { AxiosRequestConfig } from 'axios';
import AsyncLocalStorage from '../utils/AsyncLocalStorage';

const LoginController = {

  signIn: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/admin/login';

      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[로그인 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  logout: async () => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/admin/logout';

      const response: any = await Axios.post(sUrl, {});
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[로그아웃 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  changePassword: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/admin/changePassword';

      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[비밀번호 변경 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  verifyAuthToken: async () => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/admin/verifyAuthToken';

      const response: any = await Axios.post(sUrl);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[관리자 토큰 검증]' + oErr.toString(),
        data: undefined,
      };
    }
  },
};

export default LoginController;
